<template>
    <v-skeleton-loader v-if="list === false" class="mx-auto" height="318" max-width="100%" type="ossein"></v-skeleton-loader>
    <v-list v-else-if="list.length" lines="2" class="px-2" style="height:310px; overflow-y:auto;">
        <v-list-item v-ripple class="rounded py-4" v-for="item in list" :key="item.id" @click="dialogData = item; dialog = true">
            <v-list-item-title class="user-select-none mb-2">{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle class="user-select-none text-small">تاریخ انتشار: {{ moment(item.start_date).format('jYYYY/jMM/jDD') }} {{ item.creator && auth.user.employee ? `(${item.creator?.name})` : '' }}</v-list-item-subtitle>
        </v-list-item>
    </v-list>
    <div v-else class="px-4 pt-4" style="height:310px">
        <p class="text-small mb-2 text-grey-darken-1 text-center font-weight-medium">در حال حاضر اطلاعیه‌ای وجود ندارد.</p>
    </div>
    <v-dialog v-model="dialog" width="550">
        <v-card max-height="85vh">
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary text-truncate">{{ dialogData.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="px-6 pt-3">
                <div class="text-meta text-grey-darken-2 font-weight-medium mb-2" style="min-height: 180px" v-sanitize="dialogData.content"></div>
            </div>
            <v-card-actions class="py-3 px-5 bg-white">
                <span class="text-small font-weight-medium px-4 py-1 rounded text-grey-darken-2 bg-grey-lighten-3">تاریخ انتشار: {{ moment(dialogData.start_date).format('jYYYY/jMM/jDD') }}</span>
                <span class="text-small font-weight-medium ps-2 py-1 text-grey-darken-2" v-if="dialogData.creator && auth.user.employee">ایجاد کننده: {{dialogData.creator?.name}}</span>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" color="error" variant="text">بستن</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script setup>
const list = ref(false);
const dialog = ref(false);
const dialogData = ref(false);
const api = useApi();
const auth = useAuthStore();
const moment = useMoment();
function getList() {
    api.userAnnouncements().then(res => {
        if (res && res.status == 'OK')
            list.value = res.data;
    });
}
getList();
</script>
